<nav class="navbar console_topbar">
  <section class="menu_nav">
    <button class="navbar-toggler sidemenu_switch" type="button" (click)="toggleMenu(stretchMenu)">
      <i class="fa-solid fa-bars" aria-hidden="true"></i>
    </button>
    <a [routerLink]="['']" class="navbar-brand brand_logo">&nbsp;</a>
  </section>

  <section class="user_nav">
    <button id="chatButton" type="button" class="btn chat_switch" (click)="toggleChat(openChat)"><i class="far fa-comment" aria-hidden="true"></i></button>
    <form class="journey_form">
      <div ngbDropdown [spinnerLoader]="subscriptions['JourneyList']?.closed" [size]="'sm'">
        <button type="button" class="form-select custom_select_dropdown journey_dropodown" id="dropdownSeverities" ngbDropdownToggle>{{ activeJourney?.name }}</button>
        <div ngbDropdownMenu aria-labelledby="dropdownSeverities">
          @for (item of journeys; track item) {
            <button type="button" ngbDropdownItem [ngClass]="{ active: item.id === activeJourney?.id }" (click)="switchJourney(item)">
              {{ item.name }}
            </button>
          }
        </div>
      </div>
    </form>
    <button class="btn profile_switch" [ngbPopover]="popUser" [autoClose]="'outside'" [placement]="'bottom-right'" [popoverClass]="'pop_user'">
      <span class="user_name">{{ user?.firstName }} {{ user?.lastName }}</span>
      <i class="fas fa-user user_avatar" aria-hidden="true"></i>
    </button>
  </section>
</nav>

<ng-template #popUser>
  <article class="account_info">
    <header class="info_head">
      <figure class="head_image">
        <i class="fas fa-user-circle fa-6x" aria-hidden="true"></i>
      </figure>
      <h5 class="head_title">{{ user?.firstName }} {{ user?.lastName }}</h5>
      <h6 class="head_subtitle">
        <small>{{ user?.email }}</small>
      </h6>
      <ul class="list-unstyled account_action">
        <li>
          <button type="button" class="btn" (click)="logout()"><i class="material-icons" aria-hidden="true">power_settings_new</i></button>
        </li>
      </ul>
    </header>
  </article>
</ng-template>
